module.exports = __webpack_public_path__ + "static/media/knob1.da5ed031.png";